import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder } from "@angular/forms";

import { MatTabChangeEvent } from "@angular/material/tabs";

import { select, Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { AppState, loadedTenantState } from "src/app/store/reducers";

import { TranslateService } from "@ngx-translate/core";
import { SnackbarService } from "../../services/snackbar/snackbar.service";

import { BaseDatepicker, DATEPICKER_FORM } from "../../base-classes/base-datepicker/base-datepicker";

@Component({
  selector: "app-tab-datepicker",
  templateUrl: "./tab-datepicker.component.html",
  styleUrls: ["./tab-datepicker.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class TabDatepickerComponent
  extends BaseDatepicker
  implements OnInit, OnDestroy
{
  dateTimeFormat: string;
  tenantData$: Observable<any>;

  tenantDataSub: Subscription;

  dateModes = [
    {
      id: "MONTH",
      name: "Dates.monthRange",
      icon: "calendar_month",
    },
    {
      id: "WEEK",
      name: "Dates.weekRange",
      icon: "date_range",
    },
    {
      id: "YESTERDAY",
      name: "Dates.yesterdayRange",
      icon: "today",
    },
    {
      id: "TODAY",
      name: "Dates.dayRange",
      icon: "calendar_today",
    },
    {
      id: "CUSTOM",
      name: "Dates.customRange",
      icon: "edit_calendar"
    },
  ];
  
  constructor(
    public store: Store<AppState>,
    public fb: FormBuilder,
    public translate: TranslateService,
    public snackbarService: SnackbarService
  ) {
    super(store, fb, translate, snackbarService);
  }

  ngOnInit(): void {
    this.tenantData$ = this.store.pipe(select(loadedTenantState));

    this.loadTenantDateTimeFomat();
    this.createDatePickerForm();
    this.loadDatePicker();
  }

  loadTenantDateTimeFomat() {
    this.tenantDataSub = this.tenantData$.subscribe((data: any) => {
      if (data) {
        this.dateTimeFormat = data.datetimeFormat;
      }
    });
  }

  tabChanged(event: MatTabChangeEvent) {
    const { index } = event;
    this.selectedMode = this.dateModes[index].id;
    this.datepickerFormGroup.get(DATEPICKER_FORM.modes).setValue(this.selectedMode);

    this.calculateDate(this.selectedMode);
  }

  filterChanged(index: number) {
    this.selectedMode = this.dateModes[index].id;
    this.datepickerFormGroup.get(DATEPICKER_FORM.modes).setValue(this.selectedMode);

    this.calculateDate(this.selectedMode);
  }

  ngOnDestroy(): void {
    if (this.tenantDataSub) {
      this.tenantDataSub.unsubscribe();
    }
  }
}
